<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title"><strong>{{ isEditMode ? 'Edit Documentation' : 'Add Documentation' }}</strong></h3>
    <div class="header-actions">
      <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;" (click)="toggleMinimise()"
         [title]="minimise ? 'Expand' : 'Minimize'"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;" title="Close"></i>
    </div>
  </div>

  @if (!minimise) {
<div class="modal-body">
    <div class="panel panel-default">
      <!-- Loading Spinner -->
      @if (loadingData) {
<div class="loader-container">
        <div class="spinner-wrapper">
          <i class="fa fa-spinner fa-pulse fa-3x"></i>
          <p>Loading...</p>
        </div>
      </div>
}

      @if (!loadingData) {
<div class="panel-body">
        <div class="row mb-10">
          <div class="form-group col-xs-1 col-md-1">&nbsp;</div>
        </div>

        <div class="row mb-30 form-row">
          <!-- Tax Year -->
          <div class="form-group col-xs-2 col-md-1">
            <label for="level" class="control-label">Tax Year</label>
            <br>
            <strong>{{ filterTaxYear }}</strong>
          </div>

          <!-- Level Dropdown -->
          <div class="form-group col-xs-2 col-md-2">
            <label for="level" class="control-label">Level</label>
            <select class="form-control" 
                    [(ngModel)]="selectedLevel" 
                    (ngModelChange)="onSelectOption()">
              <option [ngValue]="null">-- Select Level --</option>
              @for (option of levelCodeMastData; track trackByCodeKey($index, option)) {
<option 
                      [ngValue]="option">
                {{ option.CODE_DISP_DESC }}
              </option>
}
            </select>
          </div>

          <!-- Value Dropdown Section -->
          @if (showParentMes || showDistinctMes || showHoEntities || showEachEntities || showFilingGrps) {
<div class="form-group col-xs-2 col-md-2" 
              >

            <!-- Parent ME Dropdown -->
            @if (showParentMes) {
<div>
              <label>Value</label>
              @if (!loading) {
<div>
                <select class="form-control custom-select-large" 
                        [(ngModel)]="selectedParentMe">
                  <option [ngValue]="null">-- Select Parent ME --</option>
                  @for (p of parentMEDropDown; track $index) {
<option 
                          [ngValue]="p.PARENT_ME_KEY">
                    {{ p.PARENT_ME_NAME }}
                  </option>
}
                </select>
              </div>
}
              @if (loading) {
<div class="input-group">
                <input type="text" class="form-control input-sm loading-input" disabled placeholder="loading">
                <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
              </div>
}
            </div>
}

            <!-- Distinct ME Dropdown -->
            @if (showDistinctMes) {
<div>
              <label>Value</label>
              @if (!loading) {
<div>
                <select class="form-control custom-select-large" 
                        [(ngModel)]="selectedDistinctMe">
                  <option [ngValue]="null">-- Select ME --</option>
                  @for (p of distinctMEData; track trackByKey($index, p)) {
<option 
                          [ngValue]="p.KEY">
                    {{ p.VALUE }}
                  </option>
}
                </select>
              </div>
}
              @if (loading) {
<div class="input-group">
                <input type="text" class="form-control input-sm loading-input" disabled placeholder="loading">
                <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
              </div>
}
            </div>
}

            <!-- Home Office Entity Dropdown -->
            @if (showHoEntities) {
<div>
              <label>Value</label>
              @if (!loading) {
<div>
                <select class="form-control custom-select-large" 
                        [(ngModel)]="selectedHoEntity">
                  <option [ngValue]="null">-- Select HO LEID --</option>
                  @for (s of distinctHomeOfficeData; track trackByKey($index, s)) {
<option 
                          [ngValue]="s.KEY">
                    {{ s.VALUE }}
                  </option>
}
                </select>
              </div>
}
              @if (loading) {
<div class="input-group">
                <input type="text" class="form-control input-sm loading-input" disabled placeholder="loading">
                <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
              </div>
}
            </div>
}

            <!-- Each Entity Dropdown -->
            @if (showEachEntities) {
<div>
              <label>Value</label>
              @if (!loading) {
<div>
                <select class="form-control custom-select-large" 
                        [(ngModel)]="selectedLeEntity">
                  <option [ngValue]="null">-- Select LEID --</option>
                  @for (s of codeCombinationData; track trackByKey($index, s)) {
<option 
                          [ngValue]="s.KEY">
                    {{ s.VALUE }}
                  </option>
}
                </select>
              </div>
}
              @if (loading) {
<div class="input-group">
                <input type="text" class="form-control input-sm loading-input" disabled placeholder="loading">
                <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
              </div>
}
            </div>
}

            <!-- Filing Group Dropdown -->
            @if (showFilingGrps) {
<div>
              <label>Value</label>
              @if (!loading) {
<div>
                <select class="form-control custom-select-large" 
                        [(ngModel)]="selectedFilingGrp">
                  <option [ngValue]="null">-- Select Filing Group --</option>
                  @for (h of filingGroupData; track trackByValue($index, h)) {
<option 
                          [ngValue]="h.VALUE">
                    {{ h.LABEL }}
                  </option>
}
                </select>
              </div>
}
              @if (loading) {
<div class="input-group">
                <input type="text" class="form-control input-sm loading-input" disabled placeholder="loading">
                <span class="input-group-addon"><i class="fa fa-spinner fa-pulse"></i></span>
              </div>
}
            </div>
}
          </div>
}
        </div>

        <!-- Modal Footer with buttons -->
        <div class="modal-footer">
          <button class="btn btn-info btn-sm" 
                  type="button" 
                  [disabled]="isSaveClicked" 
                  (click)="save()">
            @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
            Save
          </button>
          <button class="btn btn-danger-outline btn-sm" 
                  type="button" 
                  (click)="reset()">
            Reset
          </button>
          <button class="btn btn-warning btn-sm" 
                  type="button" 
                  (click)="cancel()">
            Cancel
          </button>
        </div>
      </div>
}
    </div>
  </div>
}
</div>
